// extracted by mini-css-extract-plugin
export default {"head":"Navbar_head__PH37T","img":"Navbar_img__cZIs+","loginBtn":"Navbar_loginBtn__wvZOF"};